<script setup lang="ts">
  import { Trash2 } from 'lucide-vue-next';
  import { Tooltip } from '@/shared/ui';

  defineProps<{
    lockMessage?: string | null;
  }>();

  const emit = defineEmits<{
    (e: 'delete'): void;
  }>();
</script>

<template>
  <Tooltip
    v-if="lockMessage"
    :content="lockMessage"
    focusable
    class="flex"
    data-testid="directories-delete-locked-tooltip"
  >
    <button
      type="button"
      disabled
      aria-label="Excluir"
      data-testid="directories-delete-locked"
      class="flex size-10.5 shrink-0 cursor-not-allowed items-center justify-center rounded-lg border border-gray-16 text-gray-16"
    >
      <Trash2 class="size-5" />
    </button>
  </Tooltip>
  <button
    v-else
    type="button"
    class="flex size-10.5 shrink-0 items-center justify-center rounded-lg border border-gray-02 text-red-16"
    aria-label="Excluir"
    @click="emit('delete')"
  >
    <Trash2 class="size-5" />
  </button>
</template>
